module.exports = __webpack_public_path__ + "static/media/use-case-9.7e745a5d.jpg";